import React, { Component } from 'react';
import ImagePreview from "../../commons/ImagePreview";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { authService } from "../../auth";
import axios from "axios";
import $, { event } from 'jquery';
import stripHtml from "string-strip-html";
import httpService from "../../AxiosInterceptors";
import cloneDeep from 'lodash/cloneDeep';
import { getCDNUrl, convertUnicode, isWebView, download_file_pdf } from "../../commons/CommonFunctions";
import * as _ from "lodash";
import PresentationViewGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import alertPopUp from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import uuid from 'react-uuid';

const ErorrMsgPopUp = withReactContent(alertPopUp);


httpService.setupInterceptors();
const maxMbFileSize = 100 * 1024 * 1024;

class CircleIntroPopUp extends Component {
    constructor(props) {
        super(props);
        let validation = {
            postText: {},
            titleText: {},
            imageList: {}
        }
        let userData = authService.getUserDetailsFromLocalStorage();
        this.state = {
            userData: userData,
            isLoading: false,
            postText: '',
            titleText: '',
            userId: '',
            validation,
            errors: {},
            isPostSubmitted: false,
            userList: [],
            isModalLoading: false,
            displayError: false,
            error: "",
            progress: 0,
            imageUrl: "",
            progressInfos: [],
            currentFile: undefined,
            displayPreview: false,
            displayVideoPreview: false,
            displayAudioPreview: false,
            forcePost: false,
            thumbnailAttachmentFile: {},
            documentTitle: "",
            displayDocumentPreview: false,
            showPresentationSection: false,
            presentationViewImagesList: [],
            presentationImages: [],
            pdfDownloadablePptUrl: "",
            uploadFiletype: "",
            thumbnailAttachmentUrl: "",
            thumbnailId: "",
            customThumbnailFlag: false,
            defaultThumbnailAttachment: {},
            fallback: false,
            intervalId: null
        }
    }

    getOptimizedImage(circleInfo) {
        if (circleInfo.resizedProfileImages && circleInfo.resizedProfileImages['200x200'] != null) {
            return circleInfo.resizedProfileImages['200x200'];
        }
        return circleInfo.profileImage;
    }

    check_words(e) {
        const BACKSPACE = 8;
        const DELETE = 46;
        const MAX_WORDS = 400;
        const valid_keys = [BACKSPACE, DELETE];
        const words = this.value.split(' ');

        if (words.length >= MAX_WORDS && valid_keys.indexOf(e.keyCode) === -1) {
            e.preventDefault();
            words.length = MAX_WORDS;
            this.value = words.join(' ');
        }
    }

    componentDidMount() {
        window.$('.dropdown-submenu > a').on("click", function (e) {
            var submenu = $(this);
            $('.dropdown-submenu .dropdown-menu').removeClass('show');
            submenu.next('.dropdown-menu').addClass('show');
            e.stopPropagation();
        });
        window.$("input#colon").on({
            // e.which >= 32 && e.which <= 47 && e.which >= 58 && e.which <= 64 && e.which >= 91 && e.which <= 95
            keypress: function (e) {
                if (e.key === '#')
                    return false;
            },
            change: function () {
                this.value = this.value.replace(/\s/g, "");
            }
        });
        var textarea = document.getElementById('input_box');
        if (textarea !== null && textarea !== ' ' && textarea !== undefined) {
            textarea.addEventListener('keydown', this.check_words);
            textarea.addEventListener('keyup', this.check_words);
        }
    }

    // Image Upload Function
    uploadImages = (e) => {
        this.setState({
            isPostSubmitted: true,
            error: "File Uploading..."
        })
        let _progressInfos = cloneDeep(this.state.progressInfos);
        _progressInfos = _progressInfos ? _progressInfos : []
        let currentArrSize = _progressInfos.length;
        let promises = []
        window.$('#circlepostImagePreview').modal('show');
        if (e.target.files && e.target.files.length > 0) {
            for (let i = 0; i < e.target.files.length; i++) {
                _progressInfos.push({
                    percentage: 0,
                    fileName: e.target.files[i].name,
                    url: URL.createObjectURL(e.target.files[i]),
                    rotationFlag: false,
                    rotationDegree: 0
                });
            }
            this.setState({
                progressInfos: _progressInfos
            });
            for (let i = 0; i < e.target.files.length; i++) {
                let currentFile = null;
                let fileSize = 0;
                currentFile = e.target.files[i];
                fileSize += e.target.files[i].size;
                const fileName = e.target.files[i].name;
                const idxDot = fileName.lastIndexOf(".") + 1;
                const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();

                const allowedAttachmentsTypeArr = ["jpg", "jpeg", "png", "gif"];

                if (!allowedAttachmentsTypeArr.includes(extFile)) {
                    this.setState({
                        error:
                            "Only " +
                            allowedAttachmentsTypeArr.join("/") +
                            " files are allowed!",
                        displayError: true,
                    });
                    document.getElementById("imageUploader").value = null;
                    setTimeout(() => {
                        this.setState({
                            error: "",
                            displayError: false,
                        });
                    }, 5000);
                    return;
                }
                if (fileSize > maxMbFileSize) {
                    this.setState({
                        error:
                            "Uploaded files exceeds limit of 100 MB. Replace/Remove some files",
                        displayError: true,
                    });
                    document.getElementById("imageUploader").value = null;
                    setTimeout(() => {
                        this.setState({
                            error: "",
                        });
                    }, 5000);
                } else {
                    if (currentFile !== null) {
                        this.setState({
                            displayPreview: true
                        })
                        // this.uploadAttachment(i, "IMAGE", currentFile);
                        promises.push(this.uploadImageAttachment(currentArrSize + i, currentFile))
                    }
                }
            }
        }
        Promise.all(promises).then((values) => {
            this.setState({
                isPostSubmitted: false,
                error: ""
            })
        }).catch((err) => {
            console.log(err)
            this.setState({
                displayPreview: false
            })
        })
    };

    uploadDocuments = (e, type) => {
        this.setState({
            isPostSubmitted: true,
            error: "File Uploading..."
        })
        let promises = []
        if (e.target.files && e.target.files.length > 0) {
            for (let i = 0; i < e.target.files.length; i++) {
                let fileSize = e.target.files[i].size;
                if (fileSize > maxMbFileSize) {
                    this.setState({
                        'error': 'Uploaded file exceeds limit of 100 MB',
                        displayError: true,
                    });
                    document.getElementById(type === "PPT" ? "pptDocumentFileUploader" : "pdfDocumentFileUploader").value = null;
                    setTimeout(() => {
                        this.setState({
                            error: ''
                        });
                    }, 5000);
                } else {
                    const fileName = document.getElementById(type === "PPT" ? "pptDocumentFileUploader" : "pdfDocumentFileUploader").value;
                    const idxDot = fileName.lastIndexOf(".") + 1;
                    const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
                    //const allowedAttachmentsTypeArr = type === "PPT" ? ["ppt", "pptx"] : ["pdf"];
                    const allowedAttachmentsTypeArr = ["ppt", "pptx", "pdf"];
                    if (allowedAttachmentsTypeArr.includes(extFile)) {
                        this.setState({
                            displayDocumentPreview: true
                        })
                        promises.push(this.uploadAttachment(e.target.files[i], extFile))
                    } else {
                        this.setState({
                            'error': 'Only ' + allowedAttachmentsTypeArr.join("/") + ' files are allowed!',
                            'displayError': true,
                            displayDocumentPreview: false
                        });
                        document.getElementById(type === "PPT" ? "pptDocumentFileUploader" : "pdfDocumentFileUploader").value = null;
                        setTimeout(() => {
                            this.setState({
                                error: '',
                                displayError: false
                            });
                        }, 5000);
                    }
                }

            }
        }
        Promise.all(promises).then((values) => {
            this.setState({
                isPostSubmitted: false,
            })
        }).catch((err) => {
            console.log(err)
            this.setState({
                'error': 'Some error occurred, Retry!',
                'displayError': true,
                displayDocumentPreview: false
            });
            document.getElementById(type === "PPT" ? "pptDocumentFileUploader" : "pdfDocumentFileUploader").value = null;
            setTimeout(() => {
                this.setState({
                    error: '',
                    displayError: false
                });
            }, 5000);
        })
    };

    //   Video Upload Function
    uploadVideoFile = (e) => {
        this.setState({
            isPostSubmitted: true,
            error: "File Uploading..."
        })
        let _progressInfos = cloneDeep(this.state.progressInfos);
        _progressInfos = _progressInfos ? _progressInfos : []
        let promises = []
        if (e.target.files && e.target.files.length > 0) {
            for (let i = 0; i < e.target.files.length; i++) {
                let fileSize = e.target.files[i].size;
                if (fileSize > maxMbFileSize) {
                    this.setState({
                        'error': 'Uploaded file exceeds limit of 100 MB',
                        displayError: true,
                    });
                    document.getElementById('videoUploadernew').value = null;
                    setTimeout(() => {
                        this.setState({
                            error: ''
                        });
                    }, 5000);
                } else {
                    window.$('#circlepostVideoPreview').modal('show');
                    _progressInfos.push({
                        percentage: 0,
                        size: e.target.files[i].size,
                        fileName: e.target.files[i].name,
                        url: URL.createObjectURL(e.target.files[i]),
                    });

                    this.setState({
                        //   videoFilePreview: URL.createObjectURL(e.target.files[i]),
                        progressInfos: _progressInfos
                    })

                    const fileName = document.getElementById("videoUploadernew").value;
                    const idxDot = fileName.lastIndexOf(".") + 1;
                    const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
                    const allowedAttachmentsTypeArr = ["mp4", "webm", "mkv", "mov", "avi", "ogg", "flv", "wmv"];
                    if (allowedAttachmentsTypeArr.includes(extFile)) {
                        this.setState({
                            displayVideoPreview: true
                        })
                        promises.push(this.uploadVideoAttachment('VIDEO', e.target.files[i]))
                        // this.uploadAttachment('VIDEO', e.target.files[0]);
                    } else {
                        this.setState({
                            'error': 'Only ' + allowedAttachmentsTypeArr.join("/") + ' files are allowed!',
                            'displayError': true,
                            videoFilePreview: null,
                            videoFile: null,
                            progressInfos: [],
                            displayVideoPreview: false
                        });
                        document.getElementById('videoUploadernew').value = null;
                        window.$('#circlepostVideoPreview').modal('hide');
                        setTimeout(() => {
                            this.setState({
                                error: '',
                                displayError: false
                            });
                        }, 5000);
                    }
                }

            }
        }
        Promise.all(promises).then((values) => {
            this.setState({
                isPostSubmitted: false,
            })
        }).catch((err) => {
            console.log(err)
            this.setState({
                'error': 'Some error occurred, Retry!',
                'displayError': true,
                videoFilePreview: null,
                videoFile: null,
                progressInfos: [],
                displayVideoPreview: false
            });
            document.getElementById('videoUploadernew').value = null;
            window.$('#circlepostVideoPreview').modal('hide');
            setTimeout(() => {
                this.setState({
                    error: '',
                    displayError: false
                });
            }, 5000);
        })
    }


    handleChangeThumbnailUpload = (e) => {
        let currentFile = e.target.files[0];
        let thunbnailAttachmentId = currentFile.length;
        const fileName = document.getElementById('thumbnailImageFileUploader').value;
        const idxDot = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
        const allowedAttachmentsTypeArr = ['jpg', 'jpeg', 'png']

        let thumbnailAttachmentFile = {
            fileName: e.target.files[0].name,
            attachmentUrl: URL.createObjectURL(e.target.files[0]),
            rotationFlag: false,
            rotationDegree: 0
        };
        this.setState({
            thumbnailAttachmentFile: thumbnailAttachmentFile
        })

        if (allowedAttachmentsTypeArr.includes(extFile)) {
            this.uploadImageAttachment(thunbnailAttachmentId, currentFile, true)
        } else {
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>{'Only ' + allowedAttachmentsTypeArr.join("/") + ' files are allowed!'}</p></>,
                })
            })
        }

    }


    //Upload Image Api Calls
    uploadImageAttachment(id, currentFile, thumbnailFlag) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("file", currentFile);
            formData.append("userId", this.state.userData.userId);
            let attachmentTypeJson = "IMAGE";
            formData.append("attachmentType", attachmentTypeJson);
            const onUploadProgress = (event) => {
                let progressInfos = cloneDeep(this.state.progressInfos);
                if (progressInfos[id]) {
                    progressInfos[id].percentage = Math.round(
                        (100 * event.loaded) / event.total
                    );
                }
                this.setState({ progressInfos: progressInfos });
            };
            axios({
                method: 'post',
                url: process.env.REACT_APP_userServiceURL + "/backend/post/uploadAttachment",
                data: formData,
                withCredentials: true,
                onUploadProgress
            }).then((response) => {
                if (response && response.data && response.data.body) {
                    if (thumbnailFlag) {
                        this.setState({ thumbnailId:response.data.body?.id,  thumbnailAttachmentUrl: response.data.body?.attachmentUrl, customThumbnailFlag: true, isPostSubmitted: false })
                    } else {
                        let imageList = cloneDeep(this.state.imageList);
                        let imagePreviewList = cloneDeep(this.state.imagePreviewList);
                        imageList = imageList ? imageList : [];
                        imagePreviewList = imagePreviewList ? imagePreviewList : [];
                        const rotationImageCount = this.state.progressInfos && this.state.progressInfos.filter(data => data.rotationFlag).length;
                        if (rotationImageCount > 0) {
                            var parsedUrl = response.data.body.attachmentUrl.substring(response.data.body.attachmentUrl.lastIndexOf("/") + 1);
                            let rotatedFilename = parsedUrl.substring(parsedUrl.indexOf("-") + 1);
                            let progressInfos = this.state.progressInfos;
                            let found = imageList.findIndex(function (item) {
                                var parsedUrl = item.attachmentUrl.substring(item.attachmentUrl.lastIndexOf("/") + 1);
                                let filename = parsedUrl.substring(parsedUrl.indexOf("-") + 1);
                                return rotatedFilename == filename;
                            });
                            if (found > -1) {
                                imageList.splice(found, 1, response.data.body);
                                progressInfos[id].rotationFlag = false;
                                this.setState({ imageList: imageList, progressInfos })
                            }
                        } else {
                            imageList.push(response.data.body);
                            imagePreviewList.push(response.data.body.attachmentUrl);
                            this.setState({
                                imageList: imageList,
                                imagePreviewList: imagePreviewList,
                                currentFile: response.data.body.attachmentUrl,
                            });
                        }
                    }

                }
                resolve();
            }).catch((e) => {
                console.log(e);
                reject(e);
            });
        });
    }

    uploadVideoAttachment(attachmentType, currentFile) {
        return new Promise((resolve, reject) => {
            this.setState({ error: 'File Uploading...' });
            const formData = new FormData();
            formData.append("file", currentFile);
            formData.append("userId", this.state.userData.userId);
            const onUploadProgress = (event) => {
                let progressInfos = cloneDeep(this.state.progressInfos);
                progressInfos[0].percentage = Math.round(
                    (100 * event.loaded) / event.total
                );
                this.setState({ progressInfos: progressInfos });
            };
            let attachmentTypeJson;
            if (attachmentType === 'SECONDARY') {
                attachmentTypeJson = 'UNKNOWN';
            } else if (attachmentType === 'WEBCAM') {
                attachmentTypeJson = 'IMAGE';
            } else {
                attachmentTypeJson = attachmentType;
            }

            formData.append("attachmentType", attachmentTypeJson);
            axios({
                method: 'post',
                url: process.env.REACT_APP_userServiceURL + "/backend/post/uploadAttachment",
                data: formData,
                withCredentials: true,
                onUploadProgress
            }).then(response => {
                this.setState({ error: '' });
                if (response && response.data.body !== null && response.data.body.id !== null) {
                    if (attachmentType === 'VIDEO') {
                        this.setState({
                            videoFilePreview: response.data.body.attachmentUrl,
                            videoFile: response.data.body.id,
                            defaultThumbnailAttachment: response.data.body,
                            thumbnailAttachmentUrl: response.data.body?.thumbnails?.length > 0 ? response.data.body?.thumbnails[0] : "",
                            thumbnailId: "",
                            customThumbnailFlag: false
                        });
                        var timesRun = 0;
                        const intervalId = setInterval(() => {
                            timesRun += 1;
                            this.getVideoThumbnailData(intervalId, timesRun);
                        }, 5000);
                    }
                    window.$('#circlepostVideoPreview').modal('hide');
                }
                resolve();
            }).catch((err) => {
                console.log(err);
                this.setState({ error: 'Please try again...', displayError: true, });
                reject(err)
                setTimeout(() => {
                    this.setState({
                        error: ''
                    });
                }, 5000);
            });
        });
    }

    imagesUpload = () => {
        this.refs.imagesFileUploader.click();
    }

    videoUpload = () => {
        this.refs.videoFileUploadernew.click();
    }

    pdfDocumentUpload = () => {
        this.refs.pdfDocumentFileUploader.click();
    }

    pptDocumentUpload = () => {
        this.refs.pptDocumentFileUploader.click();
    }

    thumbnailUpload = () => {
        this.refs.thumbnailImageFileUploader.click();
    };

    getExistingTotalAttachmentsSize() {
        let fileSize = 0;

        if (this.state.videoFile) {
            fileSize += this.state.videoFile.size;
        }

        if (this.state.imageList) {
            for (let i = 0; i < this.state.imageList.length; i++) {
                fileSize += this.state.imageList[i].size;
            }
        }

        return fileSize;
    }

    dataURItoBlob = (dataURI) => {
        // convert base64/URLEncoded data component to raw binary data held in a string
        let byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        let ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
    }

    removeVideoFile = () => {
        this.setState({
            'videoFile': null,
            'videoFilePreview': null,
            progressInfos: [],
            displayVideoPreview: false,
            displayAudioPreview: false,
            thumbnailAttachmentFile: {},
            thumbnailAttachmentUrl: "",
            thumbnailId: "",
            defaultThumbnailAttachment: {},
            customThumbnailFlag: false
        });

        window.$('#circlepostVideoPreview').modal('hide');
    }

    removeThumbnailAttachmentFile = () => {
        this.setState({
            thumbnailAttachmentFile: {},
            thumbnailAttachmentUrl: !_.isEmpty(this.state.defaultThumbnailAttachment) ? this.state.defaultThumbnailAttachment?.thumbnails?.length > 0 && this.state.defaultThumbnailAttachment?.thumbnails[0] : "",
            thumbnailId: "",
            customThumbnailFlag: false
        })
    }

    removeLocalImage = (fileDetails, index) => {
        let imagePreviewList = cloneDeep(this.state.progressInfos);
        let imageList = cloneDeep(this.state.imageList);
        let selectedFileName = fileDetails.fileName.replace(/ /g, "_").replace(/[^A-Za-z0-9_.]/ig, "");
        if (imagePreviewList && imagePreviewList.length > 0) {
            imagePreviewList.splice(index, 1);
            if (imageList) {
                let found = imageList.findIndex(function (item) {
                    var parsedUrl = item.attachmentUrl.substring(item.attachmentUrl.lastIndexOf("/") + 1);
                    let filename = parsedUrl.substring(parsedUrl.indexOf("-") + 1);
                    return selectedFileName == filename;
                });
                if (found > -1) {
                    imageList.splice(found, 1);
                }
            }
            if (imageList.length === 0) {
                //document.getElementById("imageUploader").value = null;
                window.$("#circlepostImagePreview").modal("hide");
            }
            this.setState({
                progressInfos: imagePreviewList,
                imageList: imageList,
                displayPreview: imageList && imageList.length === 0 ? false : true
            });
        }
    };

    removeImage = (index) => {
        let imagePreviewList = this.state.imagePreviewList;

        if (imagePreviewList && imagePreviewList.length > 0) {
            let imageList = this.state.imageList;
            imagePreviewList.splice(index, 1);
            imageList.splice(index, 1);

            if (imageList.length === 0) {
                document.getElementById('imageUploader').value = null;
            }
            this.setState({
                'imagePreviewList': imagePreviewList,
                'imageList': imageList
            });
        }
    }

    componentWillUnmount() {
        this.hideModal();
    }

    hideModal = () => {
        this.setState({
            'isPostSubmitted': false,
            'isLoading': false,
            'imageList': null,
            'imagePreviewList': null,
            'videoFilePreview': null,
            'videoFile': null,
            'error': null,
            'titleText': '',
            'postText': '',
            'userId': null,
            'isModalLoading': false,
            'displayPreview': false,
            'displayVideoPreview': false,
            'progressInfos': [],
        });
        if (document.getElementById('videoUploadernew')) {
            document.getElementById('videoUploadernew').value = null;
        }
        if (document.getElementById('imageUploader')) {
            document.getElementById('imageUploader').value = null;
        }
        window.$('#circletoppostwrap').modal('hide');
        window.$('#circlecancelPopup').modal('hide');
        this.props.onCloseEventPopup();
    }

    onHandleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value.trimStart()
        })
    }

    validateForm = () => {
        this.state.validation.postText = {};
        this.state.validation.titleText = {};
        this.state.validation.imageList = {};
        let errors = {};
        let formIsValid = true;
        var regex = /\s+/gi;
        if (stripHtml(this.state.postText).trim().replace(regex, ' ').split(' ').length > 400
        ) {
            formIsValid = false;
        }
        if (_.isNull(this.state.postText) || _.isUndefined(this.state.postText) || _.isEmpty(this.state.postText.trim().replace(regex, ' '))) {
            errors["postText"] = "Please enter post description";
            this.state.validation.postText = {
                error: true,
                message: 'Please enter post description',
                style: { borderColor: "#b34c4c", padding: "10px" }
            }
            formIsValid = false;

        }
        if (_.isNull(this.state.titleText) || _.isUndefined(this.state.titleText) || _.isEmpty(this.state.titleText.trim().replace(regex, ' '))) {
            errors["titleText"] = "Please enter post title";
            this.state.validation.titleText = {
                error: true,
                message: 'Please enter post title',
                style: { borderColor: "#b34c4c", padding: "10px" }
            }
            formIsValid = false;

        }
        if (this.state.titleText && stripHtml(this.state.titleText).trim().replace(regex, ' ').split(' ').length > 25
        ) {
            errors["titleText"] = "Please enter upto 25 words";
            this.state.validation.titleText = {
                error: true,
                message: 'Please enter upto 25 words',
                style: { borderColor: "#b34c4c", padding: "10px" }
            }
            formIsValid = false;
        }
        if ((!this.state.imageList || this.state.imageList.length === 0) && !this.state.videoFile && !this.state.showPresentationSection && this.state.presentationImages?.length === 0) {
            errors["imageList"] = "Please select one image, video or document";
            this.state.validation.imageList = {
                error: true,
                message: 'Please select one image, video or document',
                style: { borderColor: "#b34c4c", padding: "10px" }
            }
            formIsValid = false;
        }
        if (this.state.showPresentationSection && this.state.presentationImages?.length > 0 && !this.state.documentTitle) {
            errors["documentTitle"] = "Please add document title";
            formIsValid = false;
        }
        if (this.state.documentTitle && (this.state.documentTitle).replace(/\s/g, "").length > 60) {
            errors["documentTitle"] = "Document title should not be greater than 60 characters";
            formIsValid = false;
        }
        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    confirmModal = () => {
        window.$('#circlecancelPopup').modal('show');
        window.$('#circletoppostwrap').modal('hide');
    }

    ignoreModal = () => {
        window.$('#circlecancelPopup').modal('hide');
        window.$('#circletoppostwrap').modal('show');
    }

    rotateImage = (index) => {
        const updProgressInfos = this.state.progressInfos.map((obj, inx) => {
            if (inx == index) {
                obj.rotationFlag = true;
                obj.rotationDegree = obj.rotationDegree + 90;
                obj.rotationDegree = obj.rotationDegree >= 360 ? -360 : obj.rotationDegree;
            }
            return obj;
        })
        this.setState({ progressInfos: updProgressInfos })
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.src = this.state.progressInfos[index].url;
        img.onload = () => {
            canvas.width = img.height;
            canvas.height = img.width;
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate((this.state.progressInfos[index].rotationDegree) * (Math.PI / 180));
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            canvas.toBlob((blob) => {
                let currentFile = new File([blob], this.state.progressInfos[index].fileName, { type: "image/jpeg" });
                this.uploadImageAttachment(index, currentFile);
            }, 'image/jpeg');
        };
    };

    rotateThumbnailImage = () => {
        const rotateImageDetails = this.state.thumbnailAttachmentFile;
        rotateImageDetails.rotationDegree = rotateImageDetails.rotationDegree + 90;
        rotateImageDetails.rotationDegree = rotateImageDetails.rotationDegree >= 360 ? -360 : rotateImageDetails.rotationDegree;
        this.setState({ thumbnailAttachmentFile: rotateImageDetails, isPostSubmitted: true })
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.src = this.state.thumbnailAttachmentFile?.attachmentUrl;
        img.onload = () => {
            canvas.width = img.height;
            canvas.height = img.width;
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate((this.state.thumbnailAttachmentFile?.rotationDegree) * (Math.PI / 180));
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            canvas.toBlob((blob) => {
                let currentFile = new File([blob], this.state.thumbnailAttachmentFile?.fileName, { type: "image/jpeg" });
                this.uploadImageAttachment(uuid(), currentFile, true);
            }, 'image/jpeg');
        };
    };

    handlePostSubmit = () => {
        if (this.validateForm()) {
            const formData = new FormData();
            this.setState({ 'isPostSubmitted': true });
            let attachmentList = [];
            let errors = {};
            let params = {
                userId: this.state.userData.userId,
                circleId: this.props.circleData && this.props.circleData.id,
                description: this.state.postText.trim('\n'),
                title: this.state.titleText.trim('\n')
            }

            if (this.state.videoFile) {
                attachmentList.push(this.state.videoFile);
                params.attachmentType = 'VIDEO';
                params.attachmentIds = attachmentList;
                if (this.state.thumbnailId) {
                    params.thumbnail = this.state.thumbnailId
                }
            } else if (this.state.imageList && this.state.imageList.length > 0) {
                params.attachmentType = 'IMAGE';
                this.state.imageList && this.state.imageList.map((attachs) => { attachmentList.push(attachs.id);});
                params.attachmentIds = attachmentList;
            } else if (this.state.presentationViewImagesList && this.state.presentationViewImagesList.length > 0) {
                let presentationImages = [];
                this.state.presentationImages && this.state.presentationImages.map((image) => {
                    presentationImages.push(image)
                })
                params.attachmentIds = [];
                params.attachmentType = this.state.uploadFiletype;
                params.fileUploadRequest = {
                    images: presentationImages,
                    pdf: this.state.pdfDownloadablePptUrl,
                    title: this.state.documentTitle.replace(/\s+/g, ' ').trim(),
                    type: this.state.uploadFiletype
                }
            }

            //formData.append("data", JSON.stringify(params));

            axios({
                method: 'post',
                url: process.env.REACT_APP_userServiceURL + '/backend/circle/create/intro/post',
                data: params,
                withCredentials: true
            }).then(response => {
                if (response && response.status === 201) {
                    this.setState({ 'forcePost': false });
                    this.props.getCirclePostList()
                    this.hideModal();
                } else {
                    this.setState({ 'isPostSubmitted': false });
                }
            }).catch((err) => {
                this.setState({
                    'forcePost': true,
                    isPostSubmitted: false,
                });
            });
            this.setState({
                errors: errors
            });
        }
        setTimeout(() => {
            this.setState({
                error: '',
                errors: {}
            });
        }, 5000);
    }

    uploadAttachment(currentFile, fileType) {
        return new Promise((resolve, reject) => {
            this.setState({ error: "File Uploading..." });
            const formData = new FormData();
            formData.append("file", currentFile);
            axios({
                method: "POST",
                url: `${process.env.REACT_APP_pptCovertURL}/${fileType === "pdf" ? "convert-to-png" : "convert-to-pdf"}`,
                data: formData,
                withCredentials: false,
            })
                .then((response) => {
                    this.setState({ error: "", isPostSubmitted: false });
                    if (response && response.data && response.status === 200) {
                        let presentationViewImagesList = [];
                        this.setState({ showPresentationSection: true })
                        response.data && response.data.images && response.data.images.map((data) => {
                            presentationViewImagesList.push({ original: data, thumbnail: data })
                        })

                        this.setState({
                            presentationViewImagesList: presentationViewImagesList,
                            presentationImages: response.data?.images,
                            pdfDownloadablePptUrl: response.data?.pdf,
                            uploadFiletype: fileType === "pdf" ? "PDF" : "PPT"
                        });
                    }
                    resolve();
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ error: "Please try again...", displayError: true });
                    reject(err);
                    setTimeout(() => {
                        this.setState({
                            error: "",
                            isPostSubmitted: false,
                            displayDocumentPreview: false,
                            showPresentationSection: false,
                            presentationViewImagesList: [],
                            presentationImages: [],
                            uploadFiletype: ""
                        });
                    }, 5000);
                });
        });
    }

    customControlsPresentation = (props) => {
        return (
            <>
                {this.state.pdfDownloadablePptUrl ?
                    <button type="button" className="btn download-attachment" onClick={(e) => download_file_pdf(e, this.state.pdfDownloadablePptUrl)}>
                        <i className="iDownloadFile" />
                    </button> :
                    null
                }
            </>

        );
    };

    removeAttachments = () => {
        //document.getElementById("documentUploader").value = null;
        this.setState({
            displayDocumentPreview: false,
            showPresentationSection: false,
            presentationViewImagesList: [],
            presentationImages: [],
            uploadFiletype: ""
        });
    };

    getVideoThumbnailData = (intervalId, timesRun) => {
        if(timesRun > 3) {
            clearInterval(this.state.intervalId)
        } else {
            this.setState({
                thumbnailAttachmentUrl: this.state.thumbnailAttachmentUrl+"?"+new Date(),
                intervalId: intervalId
            })
        }
    }

    reloadSrc = e => { 
        if(this.state.fallback){
          e.target.src = "https://cdn.dscovr.com/images/video-blank2.png";
        }else{
          e.target.src = this.state.thumbnailAttachmentUrl
          this.setState({
            fallback: true
          })
        }
    }

    render() {
        var regex = /\s+/gi;
        let Stripbody = stripHtml(this.state.postText).trim().replace(regex, ' ').split(' ').length
        return (
            (
                <>
                    <div id="circletoppostwrap" className="modal fade dgpopup openPostbox">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <section className="toppostwrap">
                                        <div className="toppostinn">
                                            {this.state.error &&
                                                this.state.error === "File Uploading..." ? (
                                                <span className="alartImgUpload">
                                                    {this.state.error}
                                                </span>
                                            ) : null}
                                            <div className="toppostpopbody">
                                                <div className="toppostpoptop">
                                                    <div className="tpbfieldlogo">
                                                        <img src="https://cdn.dscovr.com/images/quotes-logo.webp"
                                                            onError={(e) => { e.target.onerror = null; e.target.src = "https://cdn.dscovr.com/images/quotes-logo.png" }}
                                                            alt="" />
                                                    </div>
                                                    <div className="tpbfield">
                                                        <form action="">
                                                            <textarea type="text"
                                                                className="form-control title"
                                                                value={this.state.titleText}
                                                                onChange={this.onHandleChange}
                                                                placeholder="Write title here..."
                                                                id="input_box"
                                                                name={"titleText"}
                                                            />
                                                            <span className="login-feedback-error mt-1"
                                                                style={{ display: "block" }}>{this.state.errors.titleText}</span>
                                                            <textarea className="form-control"
                                                                value={this.state.postText}
                                                                onChange={this.onHandleChange}
                                                                placeholder="Write description here..."
                                                                id="input_box"
                                                                name={"postText"}
                                                            />
                                                            {this.state.showPresentationSection &&
                                                                <>
                                                                    <div className="presentation-title">
                                                                        <label>Add Document title <sup className="required-field">*</sup></label>
                                                                        <input type="text" class="form-control custom-input" placeholder="Add document title here..." name="documentTitle" value={this.state.documentTitle} onChange={this.onHandleChange} />
                                                                        <span className="login-feedback-error mt-1" style={{ display: "block" }}>{this.state.errors["documentTitle"]}</span>
                                                                    </div>
                                                                    <a href="javascript:void(0)" className="closeimg d-flex justify-content-end" onClick={() => this.removeAttachments()}><i className="iCross" /></a>
                                                                    <div className={this.state.pdfDownloadablePptUrl ? "presentation-view-gallery" : ""}>
                                                                        <PresentationViewGallery items={this.state.presentationViewImagesList} showIndex={true} autoPlay={false} showThumbnails={false} showPlayButton={false} disableKeyDown={true} infinite={false} renderCustomControls={this.customControlsPresentation} />
                                                                    </div>
                                                                </>
                                                            }
                                                        </form>
                                                        {this.state.errors.postText !== 'You can not enter more then 400 words' && <span className="login-feedback-error mt-1"
                                                            style={{ display: "block" }}>{this.state.errors.postText}</span>}

                                                    </div>
                                                </div>
                                                {
                                                    this.state.imageUri &&
                                                    <ImagePreview dataUri={this.state.imageUri}
                                                        isFullscreen={false}
                                                        onCancelImage={this.onCancelImage} />
                                                }
                                                {
                                                    this.state.videoFilePreview &&
                                                    <>
                                                        <div className="imagesList">
                                                            {this.state.progressInfos &&
                                                                this.state.progressInfos.map((progressInfo, index) => (
                                                                    <div className="imagesListGrid video">
                                                                        <div className="imgGridinn">
                                                                            {" "}
                                                                            <a href="javascript:void(0)" onClick={e => {
                                                                                e.preventDefault();
                                                                                this.removeVideoFile();
                                                                            }} class="closeimg">
                                                                                <i class="iCross"></i>
                                                                            </a>
                                                                            {progressInfo.percentage < 100 ?
                                                                                <div className="imgListOverlay">

                                                                                </div> : null}
                                                                            <div className={"vidico" + ((this.state.customThumbnailFlag || this.state.thumbnailAttachmentUrl) ? " video-thumbnail" : "")}>
                                                                                {!this.state.thumbnailAttachmentUrl ? <i className="iVid" /> :
                                                                                    <>
                                                                                        <img style={{ transform: `rotate(${this.state.thumbnailAttachmentFile?.rotationDegree}deg)` }} src={getCDNUrl(this.state.customThumbnailFlag ? this.state.thumbnailAttachmentFile?.attachmentUrl : this.state.thumbnailAttachmentUrl)} alt="" onError={this.reloadSrc} />
                                                                                        {/* <img src={getCDNUrl(this.state.thumbnailAttachmentUrl)} onError={this.reloadSrc} /> */}
                                                                                        {this.state.customThumbnailFlag && 
                                                                                            <>
                                                                                                <i className="iCross" onClick={(e) => { e.preventDefault(); this.removeThumbnailAttachmentFile(); }}></i>
                                                                                                <button onClick={(e) => { e.preventDefault(); this.rotateThumbnailImage() }} type="button" className="rotateImg"><i className="irotate" /></button>
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                            </div>
                                                                            <div className="vidDesc">
                                                                                <h4>{progressInfo.fileName}</h4>
                                                                                <div className="vidDescBottInfo">
                                                                                    <span>{((progressInfo.size / 1024) / 1024).toFixed(2)} MB</span>
                                                                                    <div className="thumbBtn">
                                                                                        <input
                                                                                            type="file"
                                                                                            //   accept="image/*"
                                                                                            accept=".jpg,.jpeg,.png"
                                                                                            onChange={(e) => this.handleChangeThumbnailUpload(e)}
                                                                                            id="thumbnailImageFileUploader"
                                                                                            ref="thumbnailImageFileUploader"
                                                                                            style={{ display: "none" }}
                                                                                        />
                                                                                        {Object.keys(this.state.thumbnailAttachmentFile).length === 0 &&
                                                                                            <button type="button" className='btn' onClick={this.thumbnailUpload}>Change Thumbnail</button>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    this.state.error && this.state.error !== '' && this.state.error !== 'File Uploading...' &&
                                                    <span className={this.state.displayError ? 'login-feedback-error' : 'login-success-error'}>{this.state.error}</span>
                                                }

                                                <span className="login-feedback-error mt-1"
                                                    style={{ display: "block" }}>{this.state.errors.imageList}</span>



                                                <div className="toppostpopbott">
                                                    <div className="toppostpopfeatures">
                                                        <a href="/media-info" title="Media Info"
                                                            className="btninfo" target="_blank"><i
                                                                className="iInfo_I" /></a>

                                                        {(!this.state.displayDocumentPreview && !this.state.displayVideoPreview && !this.state.videoFile && !this.state.videoFilePreview) &&
                                                            <>
                                                                <input type="file" accept=".jpg,.jpeg,.png,.gif"
                                                                    onChange={this.uploadImages} multiple
                                                                    ref="imagesFileUploader"
                                                                    style={{ display: "none" }}
                                                                    id="imageUploader" />

                                                                <a href="javascript:void(0)"
                                                                    title="Upload Images"
                                                                    onClick={this.imagesUpload}><i
                                                                        className="iUploadPhoto" /></a>
                                                            </>
                                                        }
                                                        {(!this.state.displayDocumentPreview && !this.state.displayPreview && !this.state.displayVideoPreview && !this.state.audioFile && !this.state.videoFile && !this.state.videoFilePreview
                                                            && (!this.state.imageList || this.state.imageList.length === 0)) && !this.state.audioFilePreview &&
                                                            <>
                                                                <input type="file"
                                                                    accept=".mp4,.webm,.mkv,.mov,.avi,.ogg,.flv,.wmv"
                                                                    onChange={this.uploadVideoFile}
                                                                    ref="videoFileUploadernew"
                                                                    style={{ display: "none" }}
                                                                    id="videoUploadernew" />

                                                                <a href="javascript:void(0)"
                                                                    title="Upload Video"
                                                                    onClick={this.videoUpload}><i
                                                                        className="iAddVideo" /></a>
                                                            </>
                                                        }
                                                        {!this.state.displayDocumentPreview && !this.state.displayVideoPreview && !this.state.displayPreview &&
                                                            <>
                                                                {/* <input type="file" accept=".ppt, .pptx"
                                                                    onChange={(e) => this.uploadDocuments(e, "PPT")}
                                                                    ref="pptDocumentFileUploader"
                                                                    style={{ display: "none" }}
                                                                    id="pptDocumentFileUploader" />

                                                                <a href="javascript:void(0)"
                                                                    title="Upload Ppt"
                                                                    onClick={this.pptDocumentUpload}><i className="iPPT_New" /></a>

                                                                <input type="file" accept=".pdf"
                                                                    onChange={(e) => this.uploadDocuments(e, "PDF")}
                                                                    ref="pdfDocumentFileUploader"
                                                                    style={{ display: "none" }}
                                                                    id="pdfDocumentFileUploader" />

                                                                <a href="javascript:void(0)"
                                                                    title="Upload Pdf"
                                                                    onClick={this.pdfDocumentUpload}><i className="iClip" /></a> */}
                                                                <input type="file" accept=".ppt, .pptx, .pdf"
                                                                    onChange={(e) => this.uploadDocuments(e)}
                                                                    ref="pdfDocumentFileUploader"
                                                                    style={{ display: "none" }}
                                                                    id="pdfDocumentFileUploader" />

                                                                <a href="javascript:void(0)"
                                                                    title="Upload Ppt, Pdf"
                                                                    onClick={this.pdfDocumentUpload}><i className="fa fa-file-text-o" /></a>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="bottpostpopbody">
                                                {this.state.displayPreview === true && this.state.progressInfos && this.state.progressInfos.length > 0 ?
                                                    <div className="previewimagebtn">
                                                        <a href="#circlepostImagePreview" data-toggle="modal"><i
                                                            className="iPhotos"></i> Preview</a>
                                                    </div> : null}

                                                {this.state.displayVideoPreview && this.state.error && this.state.error === "File Uploading..." ?
                                                    <div className="previewimagebtn">
                                                        <a href="#circlepostVideoPreview" data-toggle="modal"><i
                                                            className="iPhotos"></i> Preview</a>
                                                    </div> : null}

                                                <div className="bottpostpopright">
                                                    {Stripbody > 400 ?
                                                        <div className="charechterinfo" style={{ color: "#dc3545" }}>Please enter upto 400 words
                                                        </div> :
                                                        <div className="charechterinfo">{400 - Stripbody} {400 - Stripbody <= 1 ? 'word ' : 'words '}
                                                            left
                                                        </div>}

                                                    {(this.state.titleText && this.state.titleText !== '') || (this.state.postText && this.state.postText !== '') || (this.state.imageList && this.state.imageList.length > 0) || (this.state.videoFile && this.state.videoFile.length > 0) || (this.state.presentationImages?.length > 0 && this.state.showPresentationSection) ? <a href="javascript:void(0)" className="btn cancel"
                                                        onClick={this.confirmModal}>Cancel</a> : <a href="javascript:void(0)" className="btn cancel"
                                                            onClick={this.hideModal}>Cancel</a>}
                                                    <input type="submit"
                                                        className="btn"
                                                        onClick={this.handlePostSubmit}
                                                        value={(this.state.error &&
                                                            this.state.error === "File Uploading...") || this.state.isPostSubmitted ? "Loading..." : "POST"}
                                                        disabled={(this.state.error &&
                                                            this.state.error === "File Uploading...") && this.state.isPostSubmitted} />
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Image Preview Modal */}
                    <div id="circlepostImagePreview" className="modal fade dgpopup" tabindex="-1" data-backdrop="false">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="postImagePreviewWrap">
                                        <h4>Upload Images</h4>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>

                                        <div className="imagesList">
                                            {this.state.progressInfos &&
                                                this.state.progressInfos.map((progressInfo, index) => (
                                                    <div className="imagesListGrid">
                                                        <div className="imgGridinn">
                                                            {" "}
                                                            <div className="imgGridPrevPanel">
                                                                {/* <button onClick={(e) => { e.preventDefault(); this.onclickRotateLeft(progressInfo,index)}} type="button" className="rotateImg left"><i className="iArrow-BottomLeft" /></button> */}
                                                                <img style={{ transform: `rotate(${progressInfo.rotationDegree}deg)` }} src={progressInfo.url} alt="" />
                                                                <button onClick={(e) => { e.preventDefault(); this.rotateImage(index) }} type="button" className="rotateImg"><i className="irotate" /></button>
                                                            </div>
                                                            <a href="javascript:void(0)"
                                                                className="closeimg"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.removeLocalImage(index);
                                                                }}
                                                            >
                                                                <i className="iCross" />
                                                            </a>
                                                            {progressInfo.percentage < 100 ? <div className="imgListOverlay">

                                                            </div> : null}
                                                            <div className="progress active">
                                                                <div
                                                                    className="progress-bar"
                                                                    role="progressbar"
                                                                    aria-valuenow={progressInfo.percentage}
                                                                    aria-valuemin="0"
                                                                    aria-valuemax="100"
                                                                    style={{ width: progressInfo.percentage + "%" }}
                                                                >
                                                                    {/* <span className="progress-type">{progressInfo.fileName}%</span> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Image Preview Modal */}


                    {/* Video Preview Modal */}
                    <div id="circlepostVideoPreview" className="modal fade dgpopup" tabindex="-1" data-backdrop="false">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="postImagePreviewWrap">
                                        <h4>Upload Video</h4>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>

                                        <div className="imagesList">
                                            {this.state.progressInfos &&
                                                this.state.progressInfos.map((progressInfo, index) => (
                                                    <div className="imagesListGrid video">
                                                        <div className="imgGridinn">
                                                            {" "}
                                                            {progressInfo.percentage < 100 ? <div className="imgListOverlay">

                                                            </div> : null}
                                                            <div className="progress active">
                                                                <div
                                                                    className="progress-bar"
                                                                    role="progressbar"
                                                                    aria-valuenow={progressInfo.percentage}
                                                                    aria-valuemin="0"
                                                                    aria-valuemax="100"
                                                                    style={{ width: progressInfo.percentage + "%" }}
                                                                >
                                                                </div>
                                                            </div>

                                                            <div className="vidico"><i className="iVid" /></div>
                                                            <div className="vidDesc">
                                                                <h4>{progressInfo.fileName}</h4>
                                                                <span>{((progressInfo.size / 1024) / 1024).toFixed(2)} MB</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Video Preview Modal */}

                    {/*Confirmation Modal Start*/}
                    <div className="modal fade dgpopup confirmpop"
                        id={"circlecancelPopup"} tabIndex="-1" role="dialog"
                        aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                {/* <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Cancel Confirmation</h5>                                    
                                </div> */}
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span
                                    aria-hidden="true" onClick={this.ignoreModal}>&times;</span></button>
                                <div className="confirm-popup-modal-body">Are you sure you want to cancel this post?</div>
                                <div className="modal-footer confirm-popup-modal-footer">
                                    <button type="button" className="btn btn-primary"
                                        onClick={this.hideModal}>Yes
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={this.ignoreModal}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Confirmation Modal End*/}
                </>)
        );
    }
}

export default CircleIntroPopUp;
